import React, { useEffect, useState } from "react";
import ChiTietKhachHang from "components/CommonComponent/ChiTietKhachHang";
import CustomerApi from "service/customerApi";
import { pushNotification } from "utils/notifications";
import "assets/css/popup-xem-khach-hang.css";

const LICH_SU_RONG = {
  LoaiDoiTac: "",
  TongGiaoDich: "0",
  TongTienChoVay: 0,
  List: [],
};

// Không dùng container redux customerDetail: nó ghi đè state.customer.customerDetail,
// CustomerForm đang theo dõi giá trị đó để set lại ô Họ tên của hợp đồng đang nhập
const ModalXemKhachHang = ({ customerId, onHide }) => {
  const [customer, setCustomer] = useState({
    customerLoading: false,
    customerDetail: {},
    objLichSuGiaoDich: LICH_SU_RONG,
  });

  const goiApi = (api, field, macDinh) => (payload) => {
    setCustomer((c) => ({ ...c, customerLoading: true }));
    api(payload)
      .then((response) => {
        const loi = !response.ok || !response.data || response.data.Error;
        if (loi) {
          pushNotification(
            (response.data && response.data.Message) || "Lỗi xảy ra.",
            "error",
            "TOP_CENTER",
            2000,
          );
        }
        setCustomer((c) => ({
          ...c,
          customerLoading: false,
          [field]: loi ? macDinh : response.data,
        }));
      })
      .catch(() => {
        pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
        setCustomer((c) => ({ ...c, customerLoading: false, [field]: macDinh }));
      });
  };

  useEffect(() => {
    document.body.classList.add("dang-xem-khach-hang");
    return () => document.body.classList.remove("dang-xem-khach-hang");
  }, []);

  // Form hợp đồng bên dưới cũng nghe Esc trên document để đóng cả form:
  // chặn ở pha capture của window để Esc chỉ đóng popup này
  useEffect(() => {
    const chanEsc = (event) => {
      if (event.key === "Escape") {
        event.stopPropagation();
        onHide();
      }
    };
    window.addEventListener("keydown", chanEsc, true);
    return () => window.removeEventListener("keydown", chanEsc, true);
  }, [onHide]);

  return (
    <ChiTietKhachHang
      show={true}
      onHide={onHide}
      className="popup-xem-khach-hang"
      backdropClassName="backdrop-popup-chong"
      data={{ CustomerID: customerId }}
      customer={customer}
      getDetailCustomer={goiApi(CustomerApi.detail, "customerDetail", {})}
      lichSuGiaoDich={goiApi(
        CustomerApi.lichSuGiaoDich,
        "objLichSuGiaoDich",
        LICH_SU_RONG,
      )}
    />
  );
};

export default ModalXemKhachHang;
